module.exports = __webpack_public_path__ + "static/img/contant_2.1377e29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_8/contant_2.jpg
// module id = +DwI
// module chunks = 0